import type { SVGProps } from "react";
export default function SvgProposalApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 182 187"
			{...props}
		>
			<path
				fill="#FAFF00"
				stroke="#FAFF00"
				d="M35.686 66.759h15.672c2.14 0 3.868 1.722 3.868 3.842v21.36c0 2.12-1.728 3.841-3.868 3.842H35.686c-2.14 0-3.869-1.722-3.87-3.842V70.6c0-2.12 1.73-3.842 3.87-3.842Z"
			/>
			<foreignObject width={132.645} height={188.605} x={19.5508} y={-2.30273}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1091_1296_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1091_1296)">
				<path
					fill="url(#paint0_linear_1091_1296)"
					fillOpacity={0.6}
					d="M107.827 96.302H92.155c-2.414 0-4.369-1.943-4.369-4.341V20.039c0-2.399 1.955-4.342 4.37-4.342h15.671c2.414 0 4.369 1.943 4.369 4.342V91.96c0 2.398-1.955 4.341-4.369 4.341M83.96 91.961V47.444c0-2.399-1.955-4.342-4.369-4.342H63.92c-2.414 0-4.37 1.943-4.37 4.342v44.517c0 2.398 1.956 4.341 4.37 4.341H79.59c2.414 0 4.37-1.943 4.37-4.341"
				/>
				<path
					stroke="url(#paint1_linear_1091_1296)"
					d="M63.92 43.603h15.672c2.14 0 3.868 1.722 3.868 3.841v44.517c0 2.12-1.728 3.841-3.868 3.842H63.92c-2.14 0-3.87-1.722-3.87-3.842V47.444c0-2.12 1.73-3.842 3.87-3.842Zm28.235-27.406h15.672c2.141 0 3.868 1.723 3.868 3.842v71.922c0 2.12-1.727 3.841-3.868 3.842H92.155c-2.14 0-3.869-1.722-3.869-3.842V20.039c0-2.053 1.622-3.734 3.67-3.837z"
				/>
			</g>
			<foreignObject width={181.317} height={168.286} x={0} y={18.0146}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1091_1296_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_ddddi_1091_1296)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="m140.707 55.646-19.151-19.03c-.805-.801-2.109-.801-2.914 0l-19.15 19.03c-1.298 1.289-.381 3.496 1.456 3.496h6.765C107.713 77.722 109.674 87 40 96.3h66.633c5.558 0 10.847-3.053 14.981-6.738 11.308-9.732 10.892-24.296 10.874-30.421h6.764c1.835 0 2.755-2.207 1.458-3.496z"
				/>
				<path
					stroke="url(#paint2_linear_1091_1296)"
					strokeOpacity={0.5}
					d="M118.994 36.97a1.57 1.57 0 0 1 2.21 0L140.354 56l.037.036c.925.975.239 2.606-1.139 2.606h-7.266l.001.502c.019 6.157.411 20.478-10.7 30.04l-.006.006c-4.093 3.65-9.267 6.61-14.648 6.61H47.241c13.876-1.997 24.588-4.01 32.858-6.132 9.635-2.474 15.99-5.105 20.173-8.059 4.207-2.97 6.21-6.264 7.144-10.01.924-3.703.797-7.845.797-12.457v-.5h-7.265c-1.397 0-2.08-1.672-1.104-2.642z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1091_1296"
					x1={86.0075}
					x2={86.0075}
					y1={15.6973}
					y2={96.3024}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1091_1296"
					x1={85.7421}
					x2={42.1806}
					y1={41.2998}
					y2={88.3636}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1091_1296"
					x1={90.6584}
					x2={90.6584}
					y1={36.0146}
					y2={96.3006}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1091_1296_clip_path" transform="translate(-19.55 2.303)">
					<path d="M107.827 96.302H92.155c-2.414 0-4.369-1.943-4.369-4.341V20.039c0-2.399 1.955-4.342 4.37-4.342h15.671c2.414 0 4.369 1.943 4.369 4.342V91.96c0 2.398-1.955 4.341-4.369 4.341M83.96 91.961V47.444c0-2.399-1.955-4.342-4.369-4.342H63.92c-2.414 0-4.37 1.943-4.37 4.342v44.517c0 2.398 1.956 4.341 4.37 4.341H79.59c2.414 0 4.37-1.943 4.37-4.341" />
				</clipPath>
				<clipPath id="bgblur_1_1091_1296_clip_path" transform="translate(0 -18.015)">
					<path d="m140.707 55.646-19.151-19.03c-.805-.801-2.109-.801-2.914 0l-19.15 19.03c-1.298 1.289-.381 3.496 1.456 3.496h6.765C107.713 77.722 109.674 87 40 96.3h66.633c5.558 0 10.847-3.053 14.981-6.738 11.308-9.732 10.892-24.296 10.874-30.421h6.764c1.835 0 2.755-2.207 1.458-3.496z" />
				</clipPath>
				<filter
					id="filter0_ddddi_1091_1296"
					width={132.645}
					height={188.605}
					x={19.5508}
					y={-2.30273}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1296" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1296"
						result="effect2_dropShadow_1091_1296"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1296"
						result="effect3_dropShadow_1091_1296"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1296"
						result="effect4_dropShadow_1091_1296"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1296" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1296" />
				</filter>
				<filter
					id="filter1_ddddi_1091_1296"
					width={181.317}
					height={168.286}
					x={0}
					y={18.0146}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1091_1296" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1091_1296"
						result="effect2_dropShadow_1091_1296"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1091_1296"
						result="effect3_dropShadow_1091_1296"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1091_1296"
						result="effect4_dropShadow_1091_1296"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1091_1296" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1091_1296" />
				</filter>
			</defs>
		</svg>
	);
}
